import {externalVue} from './config'
import {shared} from './shared'

const external = externalVue
export {shared, external}
